<div class="flex flex-col gap-6" *ngIf="vm$ | async as vm">
	<ng-container *ngFor="let missingField of vm.missingFields">
		<div
			class="flex justify-between self-center bg-orange-lightest w-full p-4 text-sm"
		>
			<div class="flex gap-4">
				<app-icon class="text-orange" [icon]="ICON.WARNING"></app-icon>
				{{ missingField.message }}
			</div>
			<span
				class="text-green w-fit cursor-pointer hover:underline"
				(click)="missingField.action()"
			>
				Add
			</span>
		</div>
	</ng-container>

	<div>
		<h5 class="h5 font-bold mb-4">General</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<div>Document Name</div>
			<app-input
				[ngModel]="
					vm.transferDetails?.documentName ??
					vm.transferObject?.Instrument?.Name
				"
				(debounce)="updateDocumentName($event)"
			/>
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Matter Number',
						value:
							vm.transferObject?.Instrument?.ClientFileNumber?.ReferenceNumber,
						method: goToMatterOverview,
						intercomAttr: 'transfer-matter-number',
					},
				}"
			/>

			<div class="col-span-2">
				Acting For
				<app-radio-group
					[items]="actingParties"
					[ngModel]="vm.transferDetails?.actingFor || vm.defaultActingFor"
					name="acting"
					(ngModelChange)="onChangeActingFor($event)"
				></app-radio-group>
			</div>
			<div class="col-span-2">
				Fee Payment
				<app-radio-group
					[items]="actingParties"
					(ngModelChange)="onChangeFeePayment($event)"
					[ngModel]="vm.transferDetails?.feePayment || vm.defaultFeePayment"
					name="fee"
				></app-radio-group>
			</div>

			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Sale Price*',
						value: vm.transferObject?.Instrument?.Amount,
						method: goToStatementOfAdjustment,
					},
				}"
			/>
		</div>
	</div>

	<div>
		<h5 class="h5 font-bold mb-4">Parties From</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Seller\'s Service Address',
						value:
							vm.transferObject?.Instrument?.PartiesFrom?.AddressForService,
						method: goToSellers,
					},
				}"
			></ng-container>
		</div>
	</div>
	<div>
		<h5 class="h5 font-bold mb-4">Parties To</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Capacity',
						value: CapacityTypeLabels[(capacity$ | async)?.capacityType],
						method: goToClients,
					},
				}"
			/>
			<div class="flex flex-col gap-4 col-span-2">
				<ng-container
					*ngFor="
						let partiesTo of vm.transferObject?.Instrument?.PartiesTo;
						let i = index
					"
				>
					<ui-section title="Client {{ i + 1 }}">
						<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4" section-content>
							<ng-container
								[ngTemplateOutlet]="eregField"
								[ngTemplateOutletContext]="{
									field: {
										label: 'Full Name',
										value: partiesTo?.FullName,
										method: goToClients,
									},
								}"
							/>
							<ng-container
								[ngTemplateOutlet]="eregField"
								[ngTemplateOutletContext]="{
									field: {
										label: 'Birthdate',
										value: partiesTo?.DateOfBirth,
										method: goToClients,
									},
								}"
							/>
							<ng-container
								[ngTemplateOutlet]="eregField"
								[ngTemplateOutletContext]="{
									field: {
										label: 'Service Address',
										value: partiesTo?.AddressForService,
										method: goToClients,
									},
								}"
							/>
						</div>
					</ui-section>
				</ng-container>
			</div>
		</div>
	</div>

	<div>
		<h5 class="h5 font-bold mb-4">Property</h5>
		<div class="grid grid-cols-2 p-sm gap-x-6 gap-y-4">
			<ng-container
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label: 'Interest/Estate',
						value: interestEstate$ | async,
					},
				}"
			/>

			<ng-container
				*ngFor="
					let title of (vm.matterTitles?.length ? vm.matterTitles : [{}])
						| sort: ['primary'] : ['desc']
				"
				class="mt-2"
				[ngTemplateOutlet]="eregField"
				[ngTemplateOutletContext]="{
					field: {
						label:
							title?.primary || !vm.matterTitles?.length
								? vm.pinsText + '*'
								: '',
						value: title?.pinNumber,
					},
				}"
			/>
		</div>
	</div>

	<ng-template #eregField let-field="field">
		<div>{{ field.label }}</div>
		<div
			data-intercom-target="{{ field.intercomAttr || '' }}"
			class="hover:bg-grey-veryLight duration-100 cursor-pointer rounded-sm p-1"
			(click)="!!field.method ? field.method() : goToMatterPropertyDetails()"
		>
			{{ field.value || '-' }}
		</div>
	</ng-template>
</div>
